import React, { useMemo } from 'react'
import { ReloadIcon } from '~/assets/icons'
import { mutualTheme } from '~/utils/theme'
import { FallbackPageContent } from '~/components'
import { makeStyles } from '@material-ui/styles'
import * as illustrations from '~/assets/illustrations'
import { Box, Button, Grid } from '@material-ui/core'
import { useIsMobileScreen } from '~/hooks'

type Illustration = keyof typeof illustrations

export type ErrorStateProps = {
  title?: string,
  onRetry: () => void,
  secondaryText?: string,
  illustration?: Illustration
}

const useStyles = makeStyles({
  container: {
    flexGrow: 1,
    display: 'flex',
    margin: '0 auto',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    [mutualTheme.breakpoints.up('md')]: {
      maxWidth: 580
    }
  },
  buttonsContainer: {
    width: '100%'
  },
  buttonItem: {
    flexBasis: 255
  },
  button: {
    height: 50,
    width: '100%',
    fontWeight: 700
  }
})

export const ErrorState: React.FC<ErrorStateProps> = (props) => {
  const {
    onRetry,
    illustration = 'ManWithError',
    title = 'Ops, algo deu errado!',
    secondaryText = 'Infelizmente estamos com instabilidade na conexão com o nosso servidor. Por favor tente novamente ou volte para a seção de visão geral:'
  } = props
  const classes = useStyles()

  const IllustrationComponent = useMemo(() => illustrations[illustration], [illustration])

  const isMobile = useIsMobileScreen()

  return (
    <Box className={classes.container}>
      <IllustrationComponent height={isMobile ? 115 : undefined} />

      <FallbackPageContent title={title} description={secondaryText} />

      <Grid
        className={classes.buttonsContainer}
        container
        wrap='wrap'
        spacing={2}
        alignItems='center'
        justifyContent='center'
      >
        <Grid item className={classes.buttonItem}>
          <Button
            size='large'
            color='secondary'
            onClick={onRetry}
            variant='contained'
            className={classes.button}
            startIcon={!isMobile && <ReloadIcon htmlColor={mutualTheme.palette.common.white} />}
          >
            Tentar novamente
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}
